import * as z from 'zod';

export const paymentMethodQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type PaymentMethodQueryLinkerSchema = z.infer<typeof paymentMethodQueryLinkerSchema>;
